export const bundleData = {
  'de-DE': () =>
    import(
      /* webpackChunkName: "bundle-de" */ 'i18n/locale-data/resources_de_DE.json'
    ),
  'en-US': () =>
    import(
      /* webpackChunkName: "bundle-en" */ 'i18n/locale-data/resources_en_US.json'
    ),
  'fr-FR': () =>
    import(
      /* webpackChunkName: "bundle-fr" */ 'i18n/locale-data/resources_fr_FR.json'
    ),
  'is-IS': () =>
    import(
      /* webpackChunkName: "bundle-is" */ 'i18n/locale-data/resources_is_IS.json'
    ),
  'ja-JP': () =>
    import(
      /* webpackChunkName: "bundle-jp" */ 'i18n/locale-data/resources_ja_JP.json'
    ),
  'pt-BR': () =>
    import(
      /* webpackChunkName: "bundle-br" */ 'i18n/locale-data/resources_pt_BR.json'
    ),
  'tr-TR': () =>
    import(
      /* webpackChunkName: "bundle-tr" */ 'i18n/locale-data/resources_tr_TR.json'
    ),
  'zh-CN': () =>
    import(
      /* webpackChunkName: "bundle-zh" */ 'i18n/locale-data/resources_zh_CN.json'
    ),
};
